// extracted by mini-css-extract-plugin
module.exports = {"portable":"PortableText_portable__CKnH0","slide-in-out":"PortableText_slide-in-out__GOxDO","fade-in-out":"PortableText_fade-in-out__jCQJo"};